import { getAccessToken } from '@/utils/auth';

/**
 * 权限定义
 * @see https://umijs.org/docs/max/access#access
 *
 * 在路由配置中通过 access 字段引用：
 * - 'isLogin'：登录即可访问
 * - 'isSuper'：仅超级管理员
 * - 自定义权限：在路由配置中用 access: 'hasPerm', perms: ['system:user:list']
 */
export default function access(
  initialState: { currentUser?: API.LoginUserInfo } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const roles = currentUser?.roles || [];
  const permissions = currentUser?.permissions || [];
  const isSuper = roles.includes('super');

  return {
    // 已登录
    isLogin: !!currentUser && !!getAccessToken(),
    // 超级管理员
    isSuper,
    // 通配 admin（兼容旧路由）
    canAdmin: isSuper,
    /**
     * 校验是否拥有指定权限
     * 用法：access: (state) => state.hasPerm(['system:user:list'])
     * 在路由里也可以这样用：
     *   access: 'hasPerm'，并配合 perms 字段（需自行扩展）
     * 这里同时导出一个函数，供页面内手动调用
     */
    hasPerm: (perm: string | string[]) => {
      if (isSuper) return true;
      const required = Array.isArray(perm) ? perm : [perm];
      // 有通配 * 直接放行
      if (permissions.includes('*')) return true;
      return required.some((p) =>
        permissions.includes(p),
      );
    },
    /**
     * 校验是否拥有指定角色
     */
    hasRole: (role: string | string[]) => {
      const required = Array.isArray(role) ? role : [role];
      return required.some((r) => roles.includes(r));
    },
  };
}
